import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { AsyncErrorHandler } from 'lib/ui';
import { Models } from 'models/core';
import { AddressService } from 'services/address-service';
import { CustomerService } from 'services/customer-service';
import { DepartmentService } from 'services/department-service';
import { SiteService } from 'services/site-service';
import { EventAggregator } from 'aurelia-event-aggregator';

@autoinject
export class CustomerLocalityDialog {
  protected customerId: number;

  protected customer: Models.Customer;
  protected departments: Array<Models.Department & { Sites?: Array<Models.Site> }>;
  protected addresses: Array<Models.Address>;
  protected sitesWithoutDepartment: Array<Models.Site>;

  protected departmentNewFormVisible: boolean = false;
  protected departmentEditFormVisible: number = null;
  protected siteNewFormVisible: number = null;
  protected siteEditFormVisible: number = null;
  protected addressNewFormVisible: number = null;
  protected addressEditFormVisible: number = null;

  constructor(
    protected dialogController: DialogController,
    private customerService: CustomerService,
    private departmentService: DepartmentService,
    private siteService: SiteService,
    private addressService: AddressService,
    private eventAggregator: EventAggregator
  ) {
    this.eventAggregator.subscribe('departmentListReset', () => {
      return this.getDepartments();
    });
    this.eventAggregator.subscribe('siteListReset', () => {
      return this.getDepartments();
    });
    this.eventAggregator.subscribe('addressListReset', () => {
      return this.getAddresses();
    });
    this.eventAggregator.subscribe('departmentFormNewClose', () => {
      this.departmentNewFormVisible = false;
    });
    this.eventAggregator.subscribe('departmentFormEditClose', () => {
      this.departmentEditFormVisible = null;
    });
    this.eventAggregator.subscribe('siteFormNewClose', () => {
      this.siteNewFormVisible = null;
    });
    this.eventAggregator.subscribe('siteFormEditClose', () => {
      this.siteEditFormVisible = null;
    });
    this.eventAggregator.subscribe('addressFormNewClose', () => {
      this.addressNewFormVisible = null;
    });
    this.eventAggregator.subscribe('addressFormEditClose', () => {
      this.addressEditFormVisible = null;
    });
  }

  activate(params: { customerId?: number }) {
    if (!params) return;
    this.customerId = params.customerId;
    void this.init();
  }

  async init() {
    await this.getCustomer();

    await this.getDepartments();
    await this.getAddresses();
  }

  onCreated(customerId: number) {
    this.dialogController.cancel({ customerId });
  }

  @AsyncErrorHandler
  private async getCustomer() {
    this.customer = await this.customerService.get(this.customerId);
  }

  @AsyncErrorHandler
  private async getDepartments() {
    this.departments = await this.departmentService.getAll('?$filter=CustomerId eq ' + this.customer.Id);
    const sites = await this.siteService.getByCustomer(this.customer.Id);

    for (const department of this.departments) {
      department.Sites = sites.filter((x) => x.DepartmentId === department.Id).sort((a, b) => (a.Name > b.Name ? 1 : -1));
    }

    this.sitesWithoutDepartment = sites.filter((x) => !x.DepartmentId).sort((a, b) => (a.Name > b.Name ? 1 : -1));
  }

  @AsyncErrorHandler
  private async getAddresses() {
    this.addresses = await this.addressService.getAll('?$filter=CustomerId eq ' + this.customer.Id);
  }

  protected newSite(id: number) {
    this.siteNewFormVisible = id;
  }
}
